<template>
    <vs-popup title="List item to add" class="popup-item-list-to-add" :active.sync="config.isActive">
        <div>
          <div v-for="(cate , i) in allItem" :key="i">
              <div class="border-bottom-custom" v-if="cate.item && cate.item.length > 0">
              <h4 class="py-5" :class="{'mt-0': i == 0}">{{cate.category_name}}</h4>
              <div class="border-top-custom">
              <div class="flex py-3" v-for="(item, index) in cate.item" :key="index">
                  <div class="w-7/12 sm:w-9/12 flex align-center">
                      <div>
                          <div v-if="item.image != null" class="rounded-item" style="height: 51px; width: 51px; background-size: cover; background-position: center; border: 1px solid #bfbfbf"
                              :style="`background-image: url('${item.image}')`"></div>
                          <div v-else class="rounded-item" style="height: 51px; width: 51px; background-size: cover; background-position: center; border: 1px solid #bfbfbf"
                              :style="`background-image: url('${default_image}')`"></div>
                      </div>
                      <div class="pl-4 font-bold" style="max-width: 100%; word-break: break-word; white-space: normal">
                          {{item.name}}
                      </div>
                  </div>
                  <div class="w-3/12 sm:w-2/12 flex align-center">
                      <div v-if="item.item_variants && item.item_variants[0] && item.item_variants[0].price">
                          ${{parseFloat(item.item_variants[0].price).toFixed(2)}}
                      </div>
                  </div>
                  <div class="w-2/12 sm:w-1/12 flex justify-end align-center">
                      <vs-button size="small" icon-pack="feather" icon="icon-plus" color="danger" class="align-center mr-2 text-base" @click="addItem(item)"></vs-button>
                  </div>
              </div>
              </div>
              </div>
          </div>
        </div>
        <popup-add-item-to-order :config="addItemConfig" :key="add_item_key" @AddItemToOrder="addItemToOrder"></popup-add-item-to-order>
    </vs-popup>
</template>

<script>
    import PopupAddItemToOrder from './PopupAddItemToOrder.vue';
    export default {
        name: 'popup-item-list-to-add',
        components: {
            'popup-add-item-to-order': PopupAddItemToOrder
        },
        props: {
            config: {
                type: Object,
                required: true
            }
        },
        data() {
            let allItem = [];
            let categoryList = {};
            let item_list = [];
            categoryList = this.$store.getters["category/categoryList"];
            item_list = this.$store.getters["item/list"]
            if(categoryList && categoryList.items){
              for(let i = 0; i < categoryList.items.length; i++){
                let obj = {category_name : '' , item: []};
                obj.category_name = categoryList.items[i].name;
                for(let j = 0;j<item_list.length;j++){
                  if(item_list[j].category_id == categoryList.items[i].id){
                    obj.item.push(item_list[j])
                  }
                }
                allItem.push(obj)
              }
            }
            return {
                default_image: 'https://www.mbrsg.ae/MBRSG/media/Images/no-image-icon-6.png',
                addItemConfig: {
                    isActive: false,
                    item_info: {}
                },
                add_item_key: 0,
                item_list,
                allItem
            }
        },
        methods: {
            addItem(item) {
                this.addItemConfig.item_info = item;
                this.addItemConfig.isActive = true;
                this.add_item_key++;
            },
            addItemToOrder(obj) {
                this.addItemConfig.isActive = false;
                this.$emit('AddItemToOrder', obj);
            }
        },
        computed: {
            // item_list() {
            //     return this.$store.getters["item/list"];
            // },
            // categoryList() {
            //     return this.$store.getters["category/categoryList"];
            // }
        },
        created() {
            this.$store.dispatch("item/ORDER_ITEM_LIST");
            this.$store.dispatch("category/LIST_CATEGORY");
        },
    }
</script>